import { useTranslation } from 'react-i18next';

import { Box, Button, Container, Skeleton, Stack, Typography, useTheme } from '@mui/material';

import { DetailCard } from '@frontend/features/hotel-content';
import { emptyState } from '@frontend/assets';

import { useHotelSearch } from './Search/HotelSearchContext';
import { routes } from '@frontend/router/routes';
import { useBreakpoints } from '@frontend/features/common/hooks/useBreakpoints';
import { HotelAvailabilityLayout } from './styled';
import { HotelAvailabilityFilters } from '../HotelAvailabilityFilters';

const getFaresUrl = (hotelId: number,) => {
  const currentParams = new URLSearchParams(window.location.search);
  const queryParams = new URLSearchParams();

  const from = currentParams.get('f');
  const to = currentParams.get('t');
  if (from) queryParams.append('f', from);
  if (to) queryParams.append('t', to);
  queryParams.append('propertyId', String(hotelId))
  queryParams.append('doSearch', 'true')


  return `${routes.hotels.fares}?${queryParams?.toString()}`;
};

const DetailLoader = () => {
  const { isMediumUp } = useBreakpoints();

  return (
    <Skeleton
      variant="rounded"
      height={200}
      sx={{
        position: 'relative',
        ...(isMediumUp ? { width: '840px' } : { maxWidth: '840px' }),
      }}
    />
  );
};

export const HotelAvailabilityList = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { isLargeUp } = useBreakpoints();
  const { filteredHotels, isHotelSearchLoading, searchId } = useHotelSearch();

  return (

    <Container maxWidth="lg">

      <Box
        display="flex"
        gap={3}
        my={4}
      >

        {isLargeUp && <HotelAvailabilityFilters />}

        <HotelAvailabilityLayout>
          {
            filteredHotels.length > 0 && (
              filteredHotels.filter(hotel => hotel.searchId === searchId).map((result) => (
                <DetailCard
                  key={result.nimbuxHotelId!}
                  hotel={result}
                  footer={(
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={4}
                    >
                      <Stack>
                        <Typography variant='body2' color={theme.palette.text.disabled}>
                          {t('hotels.availability.noMarkup')} {result.minPrice} USD
                        </Typography>
                        <Typography variant='h6' color={theme.palette.primary.dark}>
                          {Number(result.finalPrice).toFixed(2)} USD
                        </Typography>
                      </Stack>
                      <Button
                        variant='contained'
                        target="_blank"
                        href={getFaresUrl(
                          result.nimbuxHotelId!
                        )}
                      >
                        {t('common.takeALook')}
                      </Button>
                    </Box>
                  )}
                />
              ))
            )
          }

          {
            (isHotelSearchLoading) && (
              <>
                <DetailLoader />
                <DetailLoader />
                <DetailLoader />
              </>
            )
          }

          {
            (!isHotelSearchLoading && filteredHotels.length === 0) && (
              <>
                <Typography variant='body2'>{t('hotels.availability.empty')}</Typography>
                <img width="140px" src={emptyState} />
              </>
            )
          }
        </HotelAvailabilityLayout>
      </Box>
    </Container >

  );
};
